// Cognito (TTS Auth) is shared across all environments. The API endpoint and the
// OAuth callback are both env-driven:
//   - REACT_APP_API_V2_URL — API base (committed .env.development for local dev;
//     per-context Netlify env vars for staging/production).
//   - REACT_APP_CALLBACK_URL — the Cognito-registered callback. Leave UNSET for
//     local dev so it falls back to window.location.origin (the local Caddy host,
//     registered locally). Staging/prod AND deploy previews MUST set it in Netlify
//     to the canonical registered callback, otherwise a preview sends an
//     unregistered per-PR redirect_uri to Cognito and login fails.
const authConfig = {
  ttsAuthUrl: 'https://auth.thetappingsolution.com',
  clientId: '5r0q01dsff9ha6oaqhk7a03k7t',
  apiV2Url: process.env.REACT_APP_API_V2_URL || 'https://api.thetappingsolution.com',
  callbackUrl: process.env.REACT_APP_CALLBACK_URL || `${window.location.origin}/callback`,
};

export default authConfig;
